import React from 'react';
import ContactForm from './ContactForm';
import '../css/Contact.css';
import '../css/App.css';

function Contact() {
  return (
    <div className="w3-container" id="contact" style={{ marginTop: '75px' }}>
      {/* Titolo */}
      <h1 className="w3-xxxlarge w3-text-black"><b>Contatti</b></h1>
       <p className="w3-large w3-text-amber" style={{ marginTop: '-10px', marginBottom: '20px' }}>
        <i><b>Contattaci per un trasporto su misura per te</b></i>
      </p>
      <hr className="w3-round hr-amber" />
      
      {/* Testo introduttivo */}
      <p style={{ fontSize: '1.1rem', marginTop: '20px' }}>
        Hai bisogno di un preventivo o desideri maggiori informazioni sui nostri servizi? 
        Scrivici una email con i dettagli del trasporto: riceverai una 
        risposta chiara in tempi brevi !
      </p>

      {/* Icone social */}
      <div className="social-icons-row text-center mb-4">
         {/* eslint-disable jsx-a11y/anchor-has-content */}
        <a href="https://www.facebook.com/" className="fab fa-facebook me-2" ></a>
        <a href="https://www.instagram.com/" className="fab fa-instagram me-2" ></a>
        <a href="https://www.linkedin.com/" className="fab fa-linkedin me-2" ></a>
        <a href="https://www.tiktok.com/" className="fab fa-tiktok me-2"></a>
        {/* eslint-enable jsx-a11y/anchor-has-content */}
      </div>

      {/* Contenuto principale */}
      <div className="row" style={{ marginTop: '30px' }}>
        {/* Colonna sinistra: info + mappa */}
        <div className="col-md-6 mb-4">
          <ul className="contact-info" style={{ listStyle: 'none', paddingLeft: 0, fontSize: '1rem' }}>
            <li className="mb-3">
              <i className="fas fa-map-marker-alt fa-lg me-2"></i>
              <span style={{ fontSize: '1.1rem' }}> Via Nucifori 71, Sant'Alfio, 95010 </span>
            </li>
            <li className="mb-3">
              <i className="fas fa-envelope fa-lg me-2"></i>
              <span style={{ fontSize: '1.1rem' }}> nuciforatrasporti@gmail.com </span>
            </li>
            <li className="mb-3">
              <i className="fas fa-phone fa-lg me-2 "></i>
              <span style={{ fontSize: '1.1rem' }}> 3459861635 - 3493605356 - 3348172934 </span>
            </li>
          </ul>

          {/* Mappa */}
          <iframe
            title="Mappa sede"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6309.88755573074!2d15.134499543316808!3d37.74446318797201!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x131406a5227bdc91%3A0xc693dafe708ff72!2s95010%20Sant&#39;Alfio%20CT!5e0!3m2!1sit!2sit!4v1762337067317!5m2!1sit!2sit"
            width="100%"
            height="300"
            style={{ border: 0, borderRadius: '10px', marginTop: '15px' }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* Colonna destra: form contatti */}
        <div className="col-md-6">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default Contact;
